import React from "react";

const DynamicIcon = ({type, ...rest}) => {
    const icons = require(`@ant-design/icons`);
    const Component = icons[type];
    if (Component)
        return <Component {...rest}/>;
    return '';
};

export default DynamicIcon;
